export const MAX_TOPIC_LENGTH = 80;
export const MAX_MESSAGE_LENGTH = 4000;
